export default "__VITE_ASSET__COTPg$nx__"